import { AppState } from '../../../../app.reducers';
import { Store, select } from '@ngrx/store';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { UserProfile } from '../../models';
import { getUserProfile } from '../../redux/user.selectors';
import { UpdateUserProfileAction } from '../../redux/user.actions';
import { CustomValidators } from '../../../../shared';
import { SubSink } from 'subsink';

@Component({
  templateUrl: './edit-profile.html',
  standalone: false
})
export class EditProfileComponent implements OnInit, OnDestroy {

  image: any;
  userProfileForm: UntypedFormGroup;
  firstName: UntypedFormControl = new UntypedFormControl();
  lastName: UntypedFormControl = new UntypedFormControl();
  phone: UntypedFormControl = new UntypedFormControl();
  email: UntypedFormControl = new UntypedFormControl();
  joinedOn: Date;

  userProfile: Observable<UserProfile>;
  private subs = new SubSink();

  constructor(private router: Router,
    private store: Store<AppState>) {
  }

  ngOnInit() {
    this.initForm();

    this.userProfile = this.store.pipe(select(getUserProfile));
    this.subs.sink = this.userProfile
      .subscribe((profile) => {
        this.updateFormValues(profile);
      });
  }

  updateFormValues(userProfile: UserProfile) {

    if (userProfile == null) {
      return;
    }

    this.joinedOn = userProfile.joinedOn;

    this.userProfileForm.controls['firstName'].setValue(userProfile.firstName);
    this.userProfileForm.controls['lastName'].setValue(userProfile.lastName);
    this.userProfileForm.controls['phone'].setValue(userProfile.phone);
    this.userProfileForm.controls['email'].setValue(userProfile.email);
  }

  initForm() {
    this.userProfileForm = new UntypedFormGroup({
      firstName: this.firstName,
      lastName: this.lastName,
      phone: this.phone,
      email: new UntypedFormControl(this.email, [Validators.required, CustomValidators.emailValidator, Validators.maxLength(100)]),
      fileUpload: new UntypedFormControl()
    });
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  saveProfile() {
    const firstName = this.userProfileForm.value.firstName.trim();
    const lastName = this.userProfileForm.value.lastName.trim();
    const email = this.userProfileForm.value.email;
    const phone = this.userProfileForm.value.phone;

    const profile = new UserProfile();
    profile.firstName = firstName;
    profile.lastName = lastName;
    profile.email = email;
    profile.phone = phone;

    this.store.dispatch(new UpdateUserProfileAction(profile));
    this.router.navigateByUrl('/useraccount/user/profile');
  }

  onCancel() {
    this.router.navigate(['useraccount/user/profile']);
  }

  private goToProfile() {
    this.router.navigate(['useraccount/user/profile']);
  }
}
